// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ym-z","tupacHeader":"Zm-z","tupacHeader2":"_m-z","tupacMenu":"an-z","tupacMenu2":"bn-z","tupacMain":"cn-z","tupacMain2":"dn-z"};